export default __webpack_public_path__ + "static/media/Products_Image_04.8af573ca.png";